export const APP_STATUS_DRAFT = 'draft'
export const APP_STATUS_ACTIVE = 'active'
export const APP_STATUS_PROGRESS = 'progress'
export const APP_STATUS_AGREE = 'agree'
export const APP_STATUS_PAY = 'pay'
export const APP_STATUS_DELIVERY = 'delivery'
export const APP_STATUS_DONE = 'done'
export const APP_STATUS_ARCHIVE = 'archive'

export const statuses = [
  {
    value: APP_STATUS_DRAFT,
    label: 'Черновик',
  },
  {
    value: APP_STATUS_ACTIVE,
    label: 'Активирована',
  },
  {
    value: APP_STATUS_PROGRESS,
    label: 'В работе',
  },
  {
    value: APP_STATUS_AGREE,
    label: 'На согласовании',
  },
  {
    value: APP_STATUS_PAY,
    label: 'Ожидает оплаты',
  },
  {
    value: APP_STATUS_DELIVERY,
    label: 'Ожидает доставки',
  },
  {
    value: APP_STATUS_DONE,
    label: 'Доставлены',
  },
  {
    value: APP_STATUS_ARCHIVE,
    label: 'Архивировано',
  },
]

export const PAYMENT_TYPE = {
  cashless: {
    caption: 'Безналичный',
  },
  cash: {
    caption: 'Наличный',
  },
  postponement: {
    caption: 'Безналичный пост оплата',
  },
  postcashless: {
    caption: 'Безналичный пред оплата',
  },
}
